import {ActionHandler} from "../../../infrastructure/handlers/action-handler";

import {runInAction} from "mobx"
import {LanguageMenuModuleController} from "../language-menu-module.controller";
import {LANGUAGE_MENU} from "../language-menu-module.consts";
import type {LanguageMenuModuleState} from "../models/language-menu-module.state";

export class LanguageMenuModuleHeaderClickHandler extends ActionHandler {
  type = LANGUAGE_MENU.ACTION_TYPES.onMenuClick;
  controller: LanguageMenuModuleController;
  state: LanguageMenuModuleState;

  static injectables = [...ActionHandler.injectables];

  async action(params) {
    runInAction(() => {
      this.state.isMenuOpen = !this.state.isMenuOpen
    });
  }
}
